<template>

    <ion-row>
        <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
            <div class="padding">
                <div class="text-center">
                    <h1 class="mb-20">Pigułki wiedzy</h1>

                    <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>
                    <!--<div v-if="loading">-->
                        <!--<item-pill-skeleton v-for="(item, index) in 4" :key="index"></item-pill-skeleton>-->
                    <!--</div>-->

                    <transition name="long-fade">
                        <div v-if="!loading">
                            <div v-if="pillsCollection && pillsCollection.length" class="list list-pills">
                                <item-pill v-for="(item, index) in pillsActive" :key="'active_'+index" :data="item"></item-pill>
                                <item-pill v-for="(item, index) in pillsInactive" :key="'inactive_'+index" :data="item"></item-pill>
                            </div>
                            <div v-else class="empty">Brak danych</div>
                        </div>
                    </transition>

                </div>
            </div>
        </ion-col>
    </ion-row>

</template>

<script>

    import PillsServices from '../../../services/KnowledgeServices';
    import ItemPill from "../../../items/ItemPill.vue";
    import ItemPillSkeleton from "../../../items/skeleton/ItemPill.vue";

    export default {
        components: {
            ItemPillSkeleton,
            ItemPill
        },
        name: 'KnowledgePill',
        data: () =>({
            loading: true,
            errors: [],
            pillsCollection: []
        }),
        computed:{
            pillsActive(){
                return this.pillsCollection.filter((o) => {
                    if (o.status === true) return o;
                })
            },
            pillsInactive(){
                return this.pillsCollection.filter((o) => {
                    if (o.status === false) return o;
                })
            }
        },

        methods:{
            getData(){
                this.loading = true;
                PillsServices.getPills()
                    .then( (response) => {
                        this.pillsCollection = response.data.data;
                        this.loading = false;
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })
            }
        },

        mounted(){
            this.getData();
        }
    }

</script>